export default {"src":"/pro/_next/static/media/imx.5adbc0c2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};